// The route parameters the project views share, read without importing the router.
import { useParams } from '@tanstack/react-router'

export function useProjectParams(): { orgId: string; projectId: string } {
  const p = useParams({ strict: false }) as { orgId?: string; projectId?: string }
  return { orgId: p.orgId ?? '', projectId: p.projectId ?? '' }
}
